import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import { createBrowserHistory } from 'history';

import App from './App';
import { ScrollToTop } from './components/ScrollToTop/index';
import configureStore from './store';

import './index.css';

ReactDOM.render(
    (
        <Provider store={configureStore()}>
            <Router history={createBrowserHistory()}>
                <ScrollToTop />
                <App />
            </Router>
        </Provider>
    ),
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
